type GetTotalAndBalanceInput = {
  useCredits?: boolean
  price?: number
  balance?: number
  credits?: number
  authorizationFee?: null|number
}

const getTotalAndBalance = ({ useCredits, price, balance, credits, authorizationFee }: GetTotalAndBalanceInput) => {
  let total = price
  let creditValue
  let creditBalance

  if (balance) {
    const diffCreditTotal = balance - price
    creditBalance     = balance
    creditValue       = 0

    if (useCredits) {
      creditBalance = diffCreditTotal < 0 ? 0 : Math.abs(diffCreditTotal)
      creditValue   = Math.abs(credits)
      total         = diffCreditTotal >= 0 ? 0 : Math.abs(balance - total)
    }
  }

  if (authorizationFee) {
    total += authorizationFee
  }

  return {
    total,
    creditValue,
    creditBalance,
  }
}


export default getTotalAndBalance
